import { CheckmarkIcon, colors, VerifiedIcon } from '@chegg-ui/theme';
import React, { memo } from 'react';
import { ValuePropsProps } from './types';

import {
  Container,
  BulletList,
  Header,
  SubHeader,
  Bullet,
  IconBox,
  NewIcon,
  NewIconText,
  Footer,
} from './ValueProps.styles';

const ValueProps: React.FC<ValuePropsProps> = (props) => {
  const { data, type } = props;
  const { header, subheader, footer, styles } = data;

  return (
    <Container style={{ ...styles?.container }} data-test="value_props_container" className={type}>
      {renderHeader()}
      {renderSubHeader()}
      {renderBullets()}
      {renderFooter()}
    </Container>
  );

  function renderHeader() {
    if (!header) return null;
    return (
      <Header style={{ ...styles?.header }} data-test="value_props_header">
        {header}
      </Header>
    );
  }

  function renderSubHeader() {
    if (!subheader) return null;
    return (
      <SubHeader style={{ ...styles?.subheader }} data-test="value_props_sub_header">
        {subheader}
      </SubHeader>
    );
  }

  function renderBullets() {
    const bullets = Object.keys(data).filter((key) => key.includes('bullet'));
    if (!bullets.length) return null;
    return (
      <BulletList data-test="value_props_bullet_list">
        {bullets.map((_, index) => {
          const bulletKey = `bullet${index + 1}`;
          const iconKey = `icon${index + 1}`;
          return (
            <Bullet key={index} data-test={`value_props_${bulletKey}`}>
              <CheckmarkIcon
                size="large"
                svgColor={styles?.checkmarks?.color || colors.cheggOrange}
              />
              <span data-test={`value_props_${bulletKey}_text`} style={{ ...styles?.bullets }}>
                {data[bulletKey]}
              </span>
              {data[iconKey] && renderIcon(iconKey)}
            </Bullet>
          );
        })}
      </BulletList>
    );
  }

  function renderIcon(iconKey: string) {
    let iconEl = null;
    const iconStyle = styles?.icons?.[iconKey];
    switch (data[iconKey].toLowerCase()) {
      case 'verifiedicon':
        iconEl = <VerifiedIcon svgColor={iconStyle?.color || colors.cheggOrange} />;
        break;
      case 'newicon':
        iconEl = (
          <NewIcon style={{ backgroundColor: iconStyle?.color || colors.royal }}>
            <NewIconText>NEW!</NewIconText>
          </NewIcon>
        );
    }
    return <IconBox data-test={`value_props_bullet_${iconKey}`}>{iconEl}</IconBox>;
  }

  function renderFooter() {
    if (!footer) return null;
    return (
      <Footer style={{ ...styles?.footer }} data-test="value_props_footer">
        {footer}
      </Footer>
    );
  }
};

export default memo(ValueProps);
